import { gql } from '@apollo/client';

export const GET_ACCOUNT = gql`
  query accountQuery($accountId: ID!) {
    getAccount(accountId: $accountId) {
      accountId
      commerceComplete
      name
      businessCountry
      priceType
      defaultCurrencyCode
      getCustomerSpecificDiscounts {
        partNumber
        channel
        discountAmount
        discountType
        initialPricingLine
      }
      getProductFilters {
        type
        value
        startDate
        endDate
      }
      accountLead {
        id
        name
        email
        userImageUrl
        workPhone
        mobilePhone
      }
    }
  }
`;
